// extracted by mini-css-extract-plugin
export default {"loader":"FullScreenLoader_loader__nS2b3"};